import React from "react";
import Box from "@mui/material/Box/Box";
import { Container } from "@mui/material";

interface GeniePageProps {
  children: React.ReactNode;
  noMargin?: boolean;
}

function GeniePage({ children, noMargin }: GeniePageProps) {
  return (
    <Container maxWidth="md" sx={{ mt: noMargin ? 0 : 2, mb: 2 }}>
      {children}
    </Container>
  );
}

export default GeniePage;
